import _toArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toArray.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
var ARN_DELIMITER = ":";
var RESOURCE_DELIMITER = "/";
export var parseArn = function parseArn(value) {
  var segments = value.split(ARN_DELIMITER);
  if (segments.length < 6) return null;
  var _segments = _toArray(segments),
    arn = _segments[0],
    partition = _segments[1],
    service = _segments[2],
    region = _segments[3],
    accountId = _segments[4],
    resourcePath = _segments.slice(5);
  if (arn !== "arn" || partition === "" || service === "" || resourcePath.join(ARN_DELIMITER) === "") return null;
  var resourceId = resourcePath.map(function (resource) {
    return resource.split(RESOURCE_DELIMITER);
  }).flat();
  return {
    partition: partition,
    service: service,
    region: region,
    accountId: accountId,
    resourceId: resourceId
  };
};